import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MyProfileService } from '@src/app/modules/my-profile/my-profile.service';
import { CommonService } from '@src/app/services/common.service';
import { SwiperDirective } from '@src/app/shared/directives/swiper.directive';
import { SharedModule } from '@src/app/shared/shared.module';
import { environment } from '@src/environments/environment';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import Swiper from 'swiper';
import { SwiperContainer } from 'swiper/element';
import { SwiperOptions } from 'swiper/types/swiper-options';

interface Banner {
    title: string;
    description: string;
    img: string;
    backgroundColor: string;
    theme: 'light' | 'dark';
    link: string | string[];
}

@Component({
    selector: 'app-activity-banner',
    standalone: true,
    imports: [CommonModule, NzCarouselModule, SharedModule, SwiperDirective],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './activity-banner.component.html',
    styleUrls: ['./activity-banner.component.less'],
})
export class ActivityBannerComponent implements OnInit {
    @ViewChild('swiper') swiper: ElementRef<SwiperContainer>;

    staticBanners: Banner[];

    activeIndex = 0;

    mintingBadge = false;

    activities: any[];

    slideChange = (swiper: Swiper) => (this.activeIndex = swiper.activeIndex);

    public config: SwiperOptions = {
        autoHeight: false,
        breakpoints: {
            300: {
                height: 168,
            },
            768: {
                height: 176,
            },
        },
        height: 192,
        spaceBetween: 20,
        navigation: false,
        pagination: false,
        slidesPerView: 1,
        centeredSlides: true,
        allowTouchMove: true,
        direction: 'vertical',
        autoplay: {
            delay: 8000,
        },
        mousewheel: true,
        on: {
            slideChange: this.slideChange,
        },
    };

    constructor(public myProfileService: MyProfileService, private commonService: CommonService, private router: Router) {}

    ngOnInit() {
        this.config.direction = this.commonService.isMobile ? 'horizontal' : 'vertical';

        this.staticBanners = [
            {
                title: '<div style="display: flex; justify-content: flex-start; align-items: center; gap: 10px;"><img src="/assets/imgs/banner/hunter-agent-bot.png" alt="" style="width: 38px; height: 38px;"><span>Hunter Agent</span><img src="/assets/imgs/banner/nyx-agent-bot.png" alt="" style="width: 38px; height: 38px; margin-left:12px;"><span>Nyx Agent</span></div>',
                description: '',
                img: '/assets/imgs/banner/all-chain-trading-live.png',
                backgroundColor: '#DDDAFF',
                theme: 'light',
                link: environment.telegram.botLink,
            },
            {
                title: 'MEME Smart Buy Dashboard',
                description: 'Discover your next 1000x Meme Coin',
                img: '/assets/imgs/banner/meme-banner.png',
                backgroundColor: '#000',
                theme: 'dark',
                link: ['/meme-dashboard'],
            },
        ];
    }

    goToLink(link: string | string[]) {
        if (Array.isArray(link)) {
            this.router.navigate(link);
        } else {
            window.open(link, '_blank');
        }
    }
}
